'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listOrderHasChanged = exports.listDescriptionIsTooLong = exports.listNameIsTooLong = exports.generateKeyForListItem = exports.isStaffOnlyList = exports.getListVisibilityType = exports.isNewList = exports.isListDraft = exports.isReadalikeList = undefined;

var _constantsList = require('@bibliocommons/constants-list');

var isReadalikeList = exports.isReadalikeList = function isReadalikeList(list) {
  return list.get('listType') === 'read_a_like';
};

var isListDraft = exports.isListDraft = function isListDraft(list) {
  return list.get('isDraft');
};

var isNewList = exports.isNewList = function isNewList(list) {
  return !list.get('id');
};

var getListVisibilityType = exports.getListVisibilityType = function getListVisibilityType(list) {
  if (list.get('visibility')) {
    return list.get('visibility');
  }

  return _constantsList.VISIBILITY.NOT_VISIBLE;
};

var isStaffOnlyList = exports.isStaffOnlyList = function isStaffOnlyList(list) {
  return ['staff_picks', 'languages', 'default_newly_acquired', 'admin_newly_acquired', 'teacher_picks'].indexOf(list.get('listType')) !== -1;
};

var generateKeyForListItem = exports.generateKeyForListItem = function generateKeyForListItem(item) {
  if (item.get('type') === 'url') {
    return item.get('type') + '-' + item.getIn(['urlListItem', 'url', 'url']);
  }
  return item.get('type') + '-' + item.getIn(['bibListItem', 'id']);
};

var listNameIsTooLong = exports.listNameIsTooLong = function listNameIsTooLong(list) {
  return list.get('name', '').length > _constantsList.LIST_NAME_LENGTH_SOFT_LIMIT;
};

var listDescriptionIsTooLong = exports.listDescriptionIsTooLong = function listDescriptionIsTooLong(list) {
  return list.get('description', '').length > _constantsList.LIST_DESCRIPTION_LENGTH_SOFT_LIMIT;
};

var listOrderHasChanged = exports.listOrderHasChanged = function listOrderHasChanged(oldListItems, newListItems) {
  if (oldListItems.size === newListItems.size) {
    for (var i = 0; i < oldListItems.size; i += 1) {
      var oldItem = oldListItems.get(i);
      var newItem = newListItems.get(i);
      if (generateKeyForListItem(oldItem) !== generateKeyForListItem(newItem)) {
        return true;
      }
    }
  }

  return false;
};

exports.default = {
  isReadalikeList: isReadalikeList,
  isListDraft: isListDraft,
  isNewList: isNewList,
  isStaffOnlyList: isStaffOnlyList,
  getListVisibilityType: getListVisibilityType,
  generateKeyForListItem: generateKeyForListItem,
  listNameIsTooLong: listNameIsTooLong,
  listDescriptionIsTooLong: listDescriptionIsTooLong,
  listOrderHasChanged: listOrderHasChanged
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-list/lib/index.js
// module id = 1563
// module chunks = 1